import { render } from "./ServerSelection.vue?vue&type=template&id=438fa810&scoped=true&ts=true"
import script from "./ServerSelection.vue?vue&type=script&lang=ts"
export * from "./ServerSelection.vue?vue&type=script&lang=ts"

import "./ServerSelection.vue?vue&type=style&index=0&id=438fa810&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438fa810"]])

export default __exports__